export default class TowerError extends Error {}
